//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { EventColorEnum, PayrollOverrideType } from './Enums';

export class EventCategoryInputItem extends ItemBase {
    AllowMakeUpCredits: boolean = false;
    BlocksOtherRecurringEvents: boolean = false;
    Color: EventColorEnum = EventColorEnum.Beach;
    EmailReminderHours: number | null = null;
    Name: string | null = null;
    PayrollOverride: PayrollOverrideType = PayrollOverrideType.None;
    PayrollOverrideAmount: number = 0;
    SMSReminderHours: number | null = null;

    constructor(initializer?: Partial<EventCategoryInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "EventCategoryInputItem";
}
